import React from "react";
import "./Pager.css"

/** helper: [start..end] */
const rng = (a, b) => Array.from({ length: Math.max(0, b - a + 1) }, (_, i) => a + i);

/**
 * Возвращает массив элементов пагинации:
 * числа страниц и специальный маркер '…'
 */
function buildPages({ page, total, siblings = 1, boundaries = 1 }) {
  if (total <= 0) return [];

  const startPages = rng(1, Math.min(boundaries, total));
  const endPages = rng(Math.max(total - boundaries + 1, boundaries + 1), total);

  const left = Math.max(page - siblings, boundaries + 1);
  const right = Math.min(page + siblings, total - boundaries);

  const pages = [...startPages];

  if (left > boundaries + 1) pages.push("…");

  pages.push(...rng(left, right));

  if (right < total - boundaries) pages.push("…");

  // защитим от дублей при маленьком total
  endPages.forEach((p) => {
    if (!pages.includes(p)) pages.push(p);
  });

  // если total совсем маленький — покажем всё подряд
  if (total <= boundaries * 2 + siblings * 2 + 2) {
    return rng(1, total);
  }

  return pages;
}

export default function Pager({
  page,
  total,
  onPage,
  siblings = 1,     // сколько соседей вокруг текущей
  boundaries = 1,   // сколько страниц показывать на краях
  className = "",
}) {
  if (!total || total <= 1) return null;

  const items = buildPages({ page, total, siblings, boundaries });

  return (
    <nav className={`sem-pager ${className}`} aria-label="Pagination">
      <button
        className="sem-pager-btn"
        onClick={() => onPage(Math.max(1, page - 1))}
        disabled={page <= 1}
        aria-label="Previous page"
      >
        ‹
      </button>

      {items.map((it, idx) =>
        it === "…" ? (
          <span key={`dots-${idx}`} className="sem-pager-ellipsis" aria-hidden="true">
            …
          </span>
        ) : (
          <button
            key={it}
            className={`sem-pager-btn ${it === page ? "is-active" : ""}`}
            onClick={() => onPage(it)}
            aria-current={it === page ? "page" : undefined}
          >
            {it}
          </button>
        )
      )}

      <button
        className="sem-pager-btn"
        onClick={() => onPage(Math.min(total, page + 1))}
        disabled={page >= total}
        aria-label="Next page"
      >
        ›
      </button>
    </nav>
  );
}
